import { render } from "./MaxIcon.vue?vue&type=template&id=7b664020&scoped=true"
import script from "./MaxIcon.vue?vue&type=script&lang=js"
export * from "./MaxIcon.vue?vue&type=script&lang=js"

import "./MaxIcon.vue?vue&type=style&index=0&id=7b664020&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b664020"]])

export default __exports__